import { useState } from '@wordpress/element';
import {
  Button,
  TextControl,
  SelectControl,
  __experimentalHeading as Heading,
} from '@wordpress/components';

export default function DonationBox() {
  const data = window.DOTFW_DATA;

  const [selected, setSelected] = useState(data.currentValue || '');
  const [amountType, setAmountType] = useState(data.amountType);
  const savedCustom = sessionStorage.getItem('dotfw_last_custom');
  const [mode, setMode] = useState(data.mode || 'predefined');
  const [customValue, setCustomValue] = useState(
    data.currentValue !== undefined && data.currentValue !== null
      ? String(data.currentValue)
      : savedCustom || ''
  );
  const [loading, setLoading] = useState(false);
  const isPercentage = data.predefinedAmtType === 'dot_percentage';
  const hasDonation = Number(selected) > 0 || Number(customValue) > 0 || Number(data.currentValue) > 0;

  // AJAX CALL FOR CUSTOM INPUT //
  const sendValue = (value, overrideType) => {
    setLoading(true);
    fetch(data.ajax_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams({
        action: 'dotfw_set_donation',
        nonce: data.nonce,
        value,
        mode,
        amount_type:
          overrideType === 'percentage_dot_value'
            ? 'percentage_dot_value'
            : 'fixed_dot_value',
      }),
    }).then(() => {
      sessionStorage.setItem('dotfw_last_custom', value);
      window.location.reload();
    });
  };

  // AJAX CALL FOR PREDEFINED INPUT //
  const sendPredefinedValue = (value) => {
    setLoading(true);
  
    fetch(data.ajax_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams({
        action: 'dotfw_set_donation',
        nonce: data.nonce,
        value,
      }),
    }).then(() => window.location.reload());
  };

  // REMOVE DONATION //
  const removeDonation = () => {
    sessionStorage.removeItem('dotfw_last_custom');
    sendValue(0);
  };

  const predefinedOptions = data.predefinedValues.map((val) => ({
    label: data.predefinedAmtType === 'dot_percentage'
      ? `${val}%`
      : `${data.currency}${val}`,
    value: val,
  }));

  return (
    <div className="dotfw-card">
      
      <Heading level={2} style={{ marginBottom: '15px' }}>{data.mainTitle}</Heading>

      {/* PREDEFINED VALUES */}
      {data.selectDonationTypes === 'predefined_value' && data.predefinedFormat === 'dot_radio_btn' && (
        <>
          <div className="dotfw-options">
            {data.predefinedValues.map((val) => {
              return (
                <Button
                  key={val}
                  style={{
                    '--predefined-btn-text-size': data.predefinedValueTextSize + 'px',
                    '--predefined-btn-top-bottom-padding': data.predefinedBtnTopBtmPadding + 'px',
                    '--predefined-btn-left-right-padding': data.predefinedBtnLeftRightPadding + 'px',
                    '--predefined-btn-hover-bg-color': data.predefinedBtnHoverBgColor,
                    '--predefined-btn-hover-text-color': data.predefinedBtnHoverTextColor,
                    '--predefined-btn-active-bg-color': data.predefinedBtnActiveBgColor,
                    '--predefined-btn-active-text-color': data.predefinedBtnActiveTextColor,
                    '--predefined-btn-text-color': data.predefinedBtnTextColor,
                    backgroundColor: data.predefinedBtnBgColor,
                    color: data.predefinedBtnTextColor,
                  }}
                  className={`dotfw-pill ${selected === val && mode === 'predefined' ? 'active' : ''}`}
                  onClick={() => {
                    setMode('predefined');
                    setSelected(val);
                    sendPredefinedValue(val);
                  }}
                >
                  {isPercentage ? `${val}%` : `${data.currency}${val}`}
                </Button>
              );
            })}

            {/* OTHER */}
            {data.PredefinedShowOtherBtn === 'yes' && (
              <Button
                className={`dotfw-pill ${mode === 'other' ? 'active' : ''}`}
                style={{
                  '--predefined-btn-text-size': data.predefinedValueTextSize + 'px',
                  '--predefined-btn-top-bottom-padding': data.predefinedBtnTopBtmPadding + 'px',
                  '--predefined-btn-left-right-padding': data.predefinedBtnLeftRightPadding + 'px',
                  '--predefined-btn-hover-bg-color': data.predefinedBtnHoverBgColor,
                  '--predefined-btn-hover-text-color': data.predefinedBtnHoverTextColor,
                  '--predefined-btn-active-bg-color': data.predefinedBtnActiveBgColor,
                  '--predefined-btn-text-color': data.predefinedBtnTextColor,
                  backgroundColor: data.predefinedBtnBgColor,
                  color: data.predefinedBtnTextColor,
                }}
                onClick={() => setMode('other')}
                disabled={loading}
              >
                {data.otherText}
              </Button>
            )}
            
            {/* CUSTOM INPUT */}
            {mode === 'other' && data.PredefinedShowOtherBtn === 'yes' && (
              <div className="dotfw-custom">
                <div className="dotfw-input-wrap">
                  <TextControl
                    type="number"
                    value={customValue}
                    onChange={(val) => {
                      setCustomValue(val);
                      sessionStorage.setItem('dotfw_last_custom', val);
                    }}
                    placeholder="Enter amount"
                    disabled={loading}
                  />
                </div>
                <span style={{ fontSize: data.predefinedValueTextSize + 'px' }}>
                  {isPercentage ? '%' : data.currency}
                </span>

                <Button
                  className="dotfw-primary-btn"
                  style={{ 
                    fontSize: data.donationBtnSize + 'px', 
                    color: data.donationBtnTextColor, 
                    backgroundColor: data.donationBtnBgColor 
                  }}
                  onClick={() => {
                    setMode('other');
                    setSelected(customValue);
                    sendValue(customValue, data.predefinedAmtType);
                  }}
                  disabled={!customValue || loading}
                >
                  {loading ? 'Applying…' : data.buttonText}
                </Button>
              </div>
            )}

            {/* REMOVE */}
            {data.DisplayRemoveDonationBtn === 'yes' && (
              <div className="dotfw-actions">
                <Button
                  className="dotfw-link-btn"
                  style={{ 
                    fontSize: data.removeDonationBtnTextSize + 'px', 
                    backgroundColor: data.removeDonationBtnBgColor,
                    color: data.removeDonationBtnTextColor,
                  }}
                  onClick={removeDonation}
                  disabled={loading}
                  >
                  {data.removeText}
                </Button>
              </div>
            )}
          </div>
        </>
      )} 
      
      {data.selectDonationTypes === 'predefined_value' && data.predefinedFormat === 'dot_dropdown' && (
        <div className="dotfw-options">
          <div className="dotfw-custom">
            <SelectControl
              style={{ width: '150px', height: 'auto', '--select-font-size': data.predefinedValueTextSize + 'px' }}
              value={selected}
              options = {predefinedOptions} 
              onChange={(val) => {
                setMode('predefined');
                setSelected(val);
              }}
            />

            {/* ADD BUTTON */}
            <Button
              className="dotfw-primary-btn"
              style={{ 
                fontSize: data.donationBtnSize + 'px', 
                color: data.donationBtnTextColor, 
                backgroundColor: data.donationBtnBgColor 
              }}
              onClick={() => {
                  sendPredefinedValue(selected);
              }}
              disabled={loading}
            >
              {loading ? 'Applying…' : data.buttonText}
            </Button>
          </div>

            {/* REMOVE */}
            {data.DisplayRemoveDonationBtn === 'yes' && (
            <Button
              className="dotfw-link-btn"
              style={{ 
                fontSize: data.removeDonationBtnTextSize + 'px', 
                backgroundColor: data.removeDonationBtnBgColor,
                color: data.removeDonationBtnTextColor,
              }}
              onClick={removeDonation}
              disabled={loading}
            >
              {data.removeText}
            </Button>
            )}
        </div>
      )}

      {/* TEXT VALUE MODE */}
      {data.selectDonationTypes === 'donation_text_value' && (
        <div className="dotfw-options">
            <div className="dotfw-custom">
              {/* FIXED / PERCENTAGE SELECT */}
              <SelectControl
                className="dotfw-select"
                value={amountType}
                options = {[
                  { label: 'Fixed', value: 'fixed_dot_value' },
                  { label: 'Percentage', value: 'percentage_dot_value' }
                ]}
                onChange={(val) => setAmountType(val)}
                disabled={loading}
              />

              {/* AMOUNT INPUT */}
              <div className="dotfw-input-wrap">
                <TextControl
                  type="number"
                  value={customValue}
                  onChange={(val) => setCustomValue(val)}
                  placeholder="Enter amount"
                  disabled={loading}
                />
              </div>
              <span style={{ fontSize: '16px' }}>
                {amountType === 'percentage_dot_value' ? '%' : data.currency}
              </span>

              {/* ADD BUTTON */}
              <Button
                className="dotfw-primary-btn"
                style={{ 
                  fontSize: data.donationBtnSize + 'px', 
                  color: data.donationBtnTextColor, 
                  backgroundColor: data.donationBtnBgColor 
                }}
                onClick={() => {
                  if (!customValue) return;
                  setSelected(customValue);
                  sendValue(customValue, amountType);
                }}
                disabled={!customValue || loading}
              >
                {loading ? 'Applying…' : data.buttonText}
              </Button>
            </div>

            {/* REMOVE */}
            {data.DisplayRemoveDonationBtn === 'yes' && (
              <Button
                className="dotfw-link-btn"
                style={{ 
                  fontSize: data.removeDonationBtnTextSize + 'px', 
                  backgroundColor: data.removeDonationBtnBgColor,
                  color: data.removeDonationBtnTextColor,
                }}
                onClick={removeDonation}
                disabled={loading}
              >
                {data.removeText}
              </Button>
            )}
        </div>
      )}

      {data.altText && hasDonation && (
        <p 
          className="dotfw-helper-text" 
          style={{
            color: data.alertTextColor,
            fontSize: data.alertFontSize + 'px',
          }}
        >
          {data.altText}
        </p>
      )}
    </div>
  );
}
